import { Pipe, PipeTransform } from '@angular/core';
import { MasterMilestoneCalendarTypeEnum } from '@zaoblako/shared/modules/report/dtos/event-calendar/enums/master.milestone.calendar.type.enum';
import type { EventCalendarItemFindInterface } from '@zaoblako/shared/modules/report/dtos/event-calendar/event-calendar-item-find.dto';

const urlEventCalendarItemGroup: Record<MasterMilestoneCalendarTypeEnum, string> = {
  [MasterMilestoneCalendarTypeEnum.PROJECT]: '/project/card/',
  [MasterMilestoneCalendarTypeEnum.PROJECT_CHECKLIST]: '/project/card/',
  [MasterMilestoneCalendarTypeEnum.HELPDESK]: '/helpdesk/task/card/',
  [MasterMilestoneCalendarTypeEnum.DEAL_EVENT]: '/deal/card/ ',
  [MasterMilestoneCalendarTypeEnum.TASK_PAYMENT]: '/task/card/ '
};

@Pipe({
  standalone: true,
  name: 'convertEventCalendarItemToLink'
})
export class ConvertEventCalendarItemToLinkPipe implements PipeTransform {
  public transform(item: EventCalendarItemFindInterface): string {
    return urlEventCalendarItemGroup[item?.itemType] + item?.id;
  }
}
